import React from 'react';
import SnapAccordion from './SnapAccordion';
import { SnapButton } from './SnapButton';
import { SnapIcon } from './SnapIcon';

export type FormState = 'waiting' | 'success' | 'error';

export default function ConfirmationPage({
  currentState,
  errors,
  onOk,
}: {
  currentState: FormState;
  errors: ApiError[];
  onOk?: () => void;
}): JSX.Element {
  const stateMapper = (formState: FormState): string => {
    if (formState === 'waiting') {
      return 'Submitting your data...';
    } else if (formState === 'success') {
      return 'Your submission was successful.';
    } else {
      return 'There was an issue with your submission, please try again.';
    }
  };

  return (
    <div>
      <div className='mb-6 text-center'>
        <div className='md:full'>
          <h2 className='mb-2 text-lg font-semibold text-gray-900'>
            {stateMapper(currentState)}
          </h2>

          <div className='grid place-items-center'>
            <ul className='max-w-md space-y-1 list-inside'>
              {errors &&
                errors.length > 0 &&
                currentState !== 'waiting' &&
                errors.map((e: ApiError, idx: number) => (
                  <li className='items-center text-base' key={idx}>
                    <p className='text-lg text-red-700 mb-2'>{e.message}</p>
                    <SnapAccordion title='Details' icon='x-circle'>
                      <p>{e.details}</p>
                      <SnapButton
                        onClick={(): Promise<void> =>
                          navigator.clipboard.writeText(e.details)
                        }
                      >
                        Copy to Clipboard
                      </SnapButton>
                    </SnapAccordion>
                  </li>
                ))}
            </ul>
          </div>
        </div>
        <div className='md:full mt-4'>
          {currentState !== 'waiting' && (
            <SnapButton
              size='xl'
              variant='primary'
              on-submit-btn='false'
              onClick={(): void => {
                if (onOk) {
                  onOk();
                }
              }}
            >
              <SnapIcon icon='check-circle' />
              OK
            </SnapButton>
          )}
        </div>
      </div>
    </div>
  );
}
